import React from "react";
import { useNavigate } from "react-router-dom";

const HeaderAdmin = () => {
    const navigate = useNavigate();
  
    return (
    <header className="App-header">
        <div className="logo-container" onClick={() => {navigate('/profile')}}>
            <img src="/hydros_full_logo.png" className="App-logo" alt="logo" />
            <div className="logo-text">L'Atelier Compte-Gouttes</div>
        </div>
    </header>
    )};

export default HeaderAdmin;
